import req from '../api.js'
/* 团委工作列表 */
export const HTTP_studentiCommittee = (page, size) => req('/api/student/committee', { page, size })
/* 团委工作详情 */
export const HTTP_studentCommitteeinfo = (id) => req('/api/student/committeeinfo', { id })